var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "banner-box" }, [
    _c(
      "div",
      { staticClass: "container flex-around" },
      [
        _c(
          "div",
          { staticClass: "banner-content" },
          [
            _c("h3", { staticStyle: { "font-size": "30px" } }, [
              _vm._v("易安捷企业数字化解决方案-容易安全快捷")
            ]),
            _c("p", { staticClass: "line-section" }),
            _c("div", { staticClass: "desc-text" }, [
              _vm._m(0),
              _vm._m(1),
              _c("p", { staticClass: "text-item" }, [
                _c("i", { staticClass: "dh" }),
                _c("span", [
                  _vm._v("实现了" + _vm._s(_vm.msgInfo || "----") + "功能")
                ])
              ])
            ]),
            _c(
              "a",
              {
                staticClass: "title",
                attrs: {
                  href: "https://www.xinminghui.com/saas-apply",
                  target: "_blank"
                }
              },
              [_vm._v("立即试用")]
            ),
            _c("apply-content", { ref: "ApplyContent" })
          ],
          1
        ),
        _c("right-announce")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-item" }, [
      _c("i", { staticClass: "dh" }),
      _c("span", [_vm._v("山东易安捷科技股份有限公司是新明辉的生态链企业")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-item" }, [
      _c("i", { staticClass: "dh" }),
      _c("span", [_vm._v("其团队为新明辉量身定制了NEBULA星云系统")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65172eb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65172eb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/index/banner/Index.vue
// module id = M6e7
// module chunks = 2